module.exports = __webpack_public_path__ + "media/images/screenshots/buy-f18db93df3a37d36f0ea58b42887e937.png";